import { EMPTY_STRING } from '../../misc/strings.constants';

export const symbolRetriever = currency => {
  switch (currency) {
    case null:
    case '':
    case undefined:
      return EMPTY_STRING;
    case 'US Dollar':
    default:
      return '$';
  }
};
